<div class="splash scrollbar">
  <div class="splash_logo">
    <img alt="Papers Logo" src="assets/img/readcube-text-logo.svg" />
  </div>

  <br>
  Cite references and create bibliographies seamlessly from your ReadCube Papers library with SmartCite.
  <br>
  <br>
  Please login to access your library.
  <br>
  <br>

  <button 
    class="button-primary uppercase" 
    (click)="onLoginClick()"> 
    {{ (isLoginProcessing$ | async) ? 'Processing...' : 'Connect' }}
  </button>

  <br>
  <br>
  <br>

  <div class="splash_tutorial">
    <scs-loader *ngIf="isTutorialProcessing$ | async"></scs-loader>
    <img
      *ngIf="!(isTutorialProcessing$ | async)"
      alt="Tutorial Screenshot"
      (click)="onTutorialClick()"
      src="assets/img/sc-tutorial-thumbnail.jpg"/>
  </div>

  <br>
</div>
